import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { searchAudit, type AuditEntry } from "@/api/audit";
import { formatDate } from "@/lib/utils";

export function AuditPage() {
  const [accion, setAccion] = useState("");
  const [entidad, setEntidad] = useState("");
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [active, setActive] = useState<AuditEntry | null>(null);

  const { data } = useQuery({
    queryKey: ["audit", accion, entidad, q, page],
    queryFn: () =>
      searchAudit({
        accion: accion || undefined,
        entidad: entidad || undefined,
        q: q || undefined,
        page,
        size: 50,
      }),
  });

  return (
    <div className="p-6 space-y-4" data-testid="page-audit">
      <header>
        <h1 className="text-2xl font-semibold">Auditoría</h1>
      </header>
      <div className="card grid grid-cols-1 md:grid-cols-4 gap-2">
        <input
          className="input"
          placeholder="acción (ej. hits.descartar)"
          value={accion}
          onChange={(e) => setAccion(e.target.value)}
          data-testid="audit-accion"
        />
        <input
          className="input"
          placeholder="entidad (ej. hits)"
          value={entidad}
          onChange={(e) => setEntidad(e.target.value)}
          data-testid="audit-entidad"
        />
        <input
          className="input md:col-span-2"
          placeholder="búsqueda libre"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="audit-q"
        />
      </div>
      <div className="card">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-muted-200">
            <tr className="border-b border-border">
              <th className="py-2">Fecha</th>
              <th>Actor</th>
              <th>Acción</th>
              <th>Entidad</th>
              <th>IP</th>
              <th>Resultado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {(data?.items ?? []).map((a) => (
              <tr key={a.id} className="border-b border-border/40">
                <td className="py-2">{formatDate(a.at)}</td>
                <td>{a.actorType}{a.userId ? ` · ${a.userId}` : ""}</td>
                <td>{a.accion}</td>
                <td>
                  {a.entidad}
                  {a.entidadId ? ` #${a.entidadId}` : ""}
                </td>
                <td className="font-mono text-xs">{a.ip ?? ""}</td>
                <td>{a.outcome}</td>
                <td>
                  <button className="btn-ghost text-xs" onClick={() => setActive(a)}>
                    Detalle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <footer className="flex justify-between text-xs text-muted-200">
        <span>{data?.total ?? 0} entradas</span>
        <div className="flex gap-1">
          <button disabled={page <= 1} className="btn-ghost" onClick={() => setPage((p) => p - 1)}>
            Anterior
          </button>
          <span className="px-3 py-2">Página {page}</span>
          <button
            disabled={(data?.items?.length ?? 0) < 50}
            className="btn-ghost"
            onClick={() => setPage((p) => p + 1)}
          >
            Siguiente
          </button>
        </div>
      </footer>
      {active && (
        <div className="fixed inset-0 z-40 grid place-items-center bg-black/60 p-4">
          <div className="card w-full max-w-2xl space-y-2">
            <header className="flex items-center justify-between">
              <h2 className="font-semibold">Detalle</h2>
              <button className="btn-ghost" onClick={() => setActive(null)}>
                Cerrar
              </button>
            </header>
            <pre className="bg-surface2 rounded p-3 overflow-auto text-xs">
              {JSON.stringify(active, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}
